import { useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { ContractorFieldProperties } from '../ContractorFieldProperties'
import { LoanFieldsProperties } from '../LoanFieldsProperties'

const tabs = {
  loan: 'Loan Field Properties',
  contractor: 'Contractor Field Properties',
}

export const FieldProperties = ({ setChanged }: { setChanged: (changed: boolean) => void }) => {
  const [tab, setTab] = useState('loan')

  return (
    <div>
      <ButtonGroup title={tabs} value={tab} onChange={setTab} />
      <div className="mt-4">
        {tab === 'contractor' ? (
          <ContractorFieldProperties setChanged={setChanged} />
        ) : (
          <LoanFieldsProperties setChanged={setChanged} />
        )}
      </div>
    </div>
  )
}
